import { Col, InputNumber, Row, Space, Button, Checkbox, Tooltip, Modal, Empty, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { DownloadOutlined, PrinterOutlined, DeleteOutlined, PlusOutlined, ReloadOutlined, HistoryOutlined } from "@ant-design/icons";
import { ModalItem, ButtonItem, DatePickerItem, InputItem } from "../../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from "moment";
import "moment/locale/es";

import etiquetaEntregaInsumoPdf, { calcularAltoAutomaticoMm } from "../../../../../Pdf/etiquetaEntregaInsumoPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
moment.locale("es");

class ModalEtiquetaEntregaInsumo extends Component {
  state = {
    loading: false,
    insumo: null,
    empresa: null,
    partes: [{ cantidad: 0 }],
    fechaEmpaque: moment(),
    consumoPreferente: null,
    leyenda: "",
    anchoMm: 60,
    usarLogoAlterno: false,
    logoAplicado: "empresa",
    huboCargaInicial: false,
    pdf: null,
    historialVisible: false,
    historialLoading: false,
    historial: [],
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.setState(
        {
          partes: [{ cantidad: this.props.cantidadEntregar || 0 }],
          fechaEmpaque: moment(),
          consumoPreferente: null,
          leyenda: "",
          anchoMm: 60,
          usarLogoAlterno: false,
          logoAplicado: "empresa",
          huboCargaInicial: false,
          insumo: null,
          empresa: null,
        },
        () => this.consultarDatos()
      );
    }
  }

  consultarDatos = async (opts = {}) => {
    this.setState({ loading: true });
    try {
      const esCargaInicial = !this.state.huboCargaInicial;

      let guardado = null;
      if (esCargaInicial && this.props.pedidoId) {
        try {
          const resGuardado = await axios.post(
            "insumos/obtenerEtiquetaEntregaPedido",
            {
              empresaId: this.props.empresaId,
              pedidoId: this.props.pedidoId,
              insumoId: this.props.insumoId,
              entregadoPrevio: this.props.entregadoPrevio || 0,
              cantidadEtiqueta: this.props.cantidadEntregar || 0,
            },
            { headers: this.props.headersToken }
          );
          if (resGuardado.data.success === 2) guardado = resGuardado.data.etiqueta;
        } catch (e) {
        }
      }

      const forzarLogoAlterno =
        typeof opts.forzarLogoAlterno === "boolean"
          ? opts.forzarLogoAlterno
          : guardado
          ? !!guardado.usarLogoAlterno
          : undefined;

      const res = await axios.post(
        "insumos/datosEtiquetaInsumoPdf",
        {
          insumoId: this.props.insumoId,
          empresaId: this.props.empresaId,
          clienteId: this.props.clienteId,
          ...(typeof forzarLogoAlterno === "boolean" ? { forzarLogoAlterno } : {}),
        },
        { headers: this.props.headersToken }
      );

      if (res.data.success !== 2) {
        message.error("No se encontraron datos del insumo");
        this.setState({ loading: false });
        return;
      }

      if (!esCargaInicial) {
        this.setState(
          {
            insumo: res.data.insumo,
            empresa: res.data.empresa,
            logoAplicado: res.data.logoAplicado,
            loading: false,
          },
          () => {
            this.generarPdf();
            this.guardarEtiqueta();
          }
        );
        return;
      }

      const anchoMm = guardado?.anchoMm || res.data.empresa?.etiquetaEntregaPedidoAnchoMm || 60;
      const leyendaDefault = res.data.empresa?.etiquetaEntregaPedidoLeyenda || "";

      this.setState(
        {
          insumo: res.data.insumo,
          empresa: res.data.empresa,
          logoAplicado: res.data.logoAplicado,
          loading: false,
          anchoMm,
          leyenda: guardado?.leyenda ?? leyendaDefault,
          partes: guardado?.partes?.length ? guardado.partes : [{ cantidad: this.props.cantidadEntregar || 0 }],
          fechaEmpaque: guardado?.fechaEmpaque ? moment(guardado.fechaEmpaque) : moment(),
          consumoPreferente: guardado?.consumoPreferente ? moment(guardado.consumoPreferente) : null,
          usarLogoAlterno: guardado ? !!guardado.usarLogoAlterno : res.data.logoAplicado === "alterno",
          huboCargaInicial: true,
        },
        () => this.generarPdf()
      );
    } catch (e) {
      message.error("Error al generar el documento");
      this.setState({ loading: false });
    }
  };

  guardarEtiqueta = () => {
    if (!this.props.pedidoId) return;
    const { partes, fechaEmpaque, consumoPreferente, leyenda, anchoMm, usarLogoAlterno } = this.state;
    axios
      .post(
        "insumos/guardarEtiquetaEntregaPedido",
        {
          empresaId: this.props.empresaId,
          pedidoId: this.props.pedidoId,
          insumoId: this.props.insumoId,
          entregadoPrevio: this.props.entregadoPrevio || 0,
          cantidadEtiqueta: this.props.cantidadEntregar || 0,
          partes,
          fechaEmpaque,
          consumoPreferente,
          leyenda,
          anchoMm,
          usarLogoAlterno,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) {
          message.warning("No se pudo guardar la etiqueta para recuperarla después (sí se generó el PDF).");
        }
      })
      .catch(() => {
        message.warning("No se pudo guardar la etiqueta para recuperarla después (sí se generó el PDF).");
      });
  };

  generarPdf() {
    const { insumo, empresa, partes, fechaEmpaque, consumoPreferente, leyenda, anchoMm } = this.state;
    if (!insumo || !empresa) return;

    const datos = {
      insumo,
      empresa,
      piezas: partes,
      fechaEmpaque,
      consumoPreferente,
      leyenda,
    };

    etiquetaEntregaInsumoPdf(datos, { anchoMm }).then((dd) => {
      const pdf = pdfMake.createPdf(dd);
      this.setState({ pdf }, () => {
        pdf.open({}, window.frames["EtiquetaEntregaInsumoIframe"]);
      });
    });
  }

  onChangeUsarLogoAlterno = (e) => {
    this.setState({ usarLogoAlterno: e.target.checked });
  };

  regenerar = () => {
    this.consultarDatos({ forzarLogoAlterno: this.state.usarLogoAlterno });
  };

  onChangeParteCantidad = (index, valor) => {
    const partes = [...this.state.partes];
    partes[index] = { ...partes[index], cantidad: Number(valor) || 0 };
    this.setState({ partes });
  };

  agregarParte = () => {
    this.setState({ partes: [...this.state.partes, { cantidad: 0 }] });
  };

  quitarParte = (index) => {
    const partes = this.state.partes.filter((_, i) => i !== index);
    this.setState({ partes });
  };

  onChangeFechaEmpaque = (valor) => {
    this.setState({ fechaEmpaque: valor });
  };

  onChangeConsumoPreferente = (valor) => {
    this.setState({ consumoPreferente: valor });
  };

  onChangeLeyenda = (e) => {
    this.setState({ leyenda: e.target.value });
  };

  onChangeAnchoMm = (valor) => {
    this.setState({ anchoMm: Math.max(60, Number(valor) || 60) });
  };

  descargarPdf() {
    if (this.state.pdf) {
      const clave = this.state.insumo?.clave || this.state.insumo?.codigo || "Insumo";
      this.state.pdf.download(`Etiqueta_Empaque_${clave}.pdf`);
    }
  }

  imprimir = () => {
    if (!this.state.pdf) return;
    this.state.pdf.print();
  };

  handleCancel = () => {
    if (this.state.huboCargaInicial) {
      this.guardarEtiqueta();
    }
    this.props.cerrarModal?.();
  };

  abrirHistorial = async () => {
    this.setState({ historialVisible: true, historialLoading: true });
    try {
      const res = await axios.post(
        "insumos/listarEtiquetasEntregaPedido",
        {
          empresaId: this.props.empresaId,
          pedidoId: this.props.pedidoId,
          insumoId: this.props.insumoId,
        },
        { headers: this.props.headersToken }
      );
      this.setState({
        historial: res.data.success === 2 ? res.data.etiquetas : [],
        historialLoading: false,
      });
    } catch (e) {
      message.error("No se pudo cargar el historial de entregas");
      this.setState({ historialLoading: false });
    }
  };

  cerrarHistorial = () => {
    this.setState({ historialVisible: false, historial: [] });
  };

  usarEntradaHistorial = async (entry, accion) => {
    try {
      const res = await axios.post(
        "insumos/datosEtiquetaInsumoPdf",
        {
          insumoId: this.props.insumoId,
          empresaId: this.props.empresaId,
          clienteId: this.props.clienteId,
          forzarLogoAlterno: !!entry.usarLogoAlterno,
        },
        { headers: this.props.headersToken }
      );
      if (res.data.success !== 2) {
        message.error("No se pudo generar esta etiqueta del historial");
        return;
      }
      const datos = {
        insumo: res.data.insumo,
        empresa: res.data.empresa,
        piezas: entry.partes,
        fechaEmpaque: entry.fechaEmpaque,
        consumoPreferente: entry.consumoPreferente,
        leyenda: entry.leyenda,
      };
      const dd = await etiquetaEntregaInsumoPdf(datos, { anchoMm: entry.anchoMm });
      const pdf = pdfMake.createPdf(dd);
      if (accion === "imprimir") {
        pdf.print();
      } else {
        const clave = res.data.insumo?.clave || res.data.insumo?.codigo || "Insumo";
        pdf.download(`Etiqueta_Empaque_${clave}_${moment(entry.createdAt).format("YYYYMMDD_HHmm")}.pdf`);
      }
    } catch (e) {
      message.error("Error al generar la etiqueta del historial");
    }
  };

  render() {
    const { partes, fechaEmpaque, consumoPreferente, leyenda, anchoMm, usarLogoAlterno, empresa, insumo, historialVisible, historialLoading, historial } = this.state;
    const cantidadEntregar = Number(this.props.cantidadEntregar) || 0;
    const puedeUsarLogoAlterno = !!this.props.clienteId && !!empresa?.complementoEmpresaAlterna;
    const altoCalculado = insumo ? calcularAltoAutomaticoMm(anchoMm, insumo?.descripcion, !!leyenda) : null;
    const repartido = partes.reduce((s, p) => s + (Number(p.cantidad) || 0), 0);
    const hayPiezaEnCero = partes.some((p) => !(Number(p.cantidad) > 0));
    const cuadra = repartido === cantidadEntregar && cantidadEntregar > 0 && !hayPiezaEnCero;

    return (
      <>
      <ModalItem
        title="Etiqueta de Empaque"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.handleCancel}
        paddingTop
        width={950}
        footer={null}
      >
        <div style={{ marginBottom: 12 }}>
          <Row gutter={[12, 8]} align="middle">
            <Col xs={24} sm={8}>
              <label style={{ fontWeight: 600, display: "block" }}>Fecha de Empaque</label>
              <DatePickerItem
                style={{ width: "100%" }}
                value={fechaEmpaque}
                onChange={this.onChangeFechaEmpaque}
                allowClear={false}
              />
            </Col>
            <Col xs={24} sm={8}>
              <label style={{ fontWeight: 600, display: "block" }}>Consumo Preferente</label>
              <DatePickerItem
                style={{ width: "100%" }}
                value={consumoPreferente}
                onChange={this.onChangeConsumoPreferente}
                placeholder="Consumo Preferente"
              />
            </Col>
            <Col xs={24} sm={8}>
              <label style={{ fontWeight: 600, display: "block" }}>Leyenda (opcional)</label>
              <InputItem
                placeholder="Ej. Consérvese refrigerado"
                value={leyenda}
                onChange={this.onChangeLeyenda}
              />
            </Col>
          </Row>

          <div style={{ marginTop: 12 }}>
            <label style={{ fontWeight: 600, display: "block", marginBottom: 4 }}>
              Piezas / Etiquetas a generar
            </label>
            {partes.map((parte, index) => {
              const enCero = !(Number(parte.cantidad) > 0);
              return (
                <Row key={index} gutter={8} align="middle" style={{ marginBottom: 6 }}>
                  <Col>
                    <span style={{ color: enCero ? "#cf1322" : undefined }}>Pieza {index + 1}:</span>
                  </Col>
                  <Col>
                    <InputNumber
                      min={0}
                      value={parte.cantidad}
                      onChange={(v) => this.onChangeParteCantidad(index, v)}
                      style={{ width: 120, borderColor: enCero ? "#ff4d4f" : undefined }}
                    />
                  </Col>
                  <Col>
                    {enCero && (
                      <span style={{ color: "#cf1322", fontSize: 12 }}>Ponle una cantidad o quítala</span>
                    )}
                  </Col>
                  <Col>
                    {partes.length > 1 && (
                      <Button
                        type="text"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => this.quitarParte(index)}
                      />
                    )}
                  </Col>
                </Row>
              );
            })}
            <Button type="dashed" icon={<PlusOutlined />} onClick={this.agregarParte}>
              Agregar pieza
            </Button>
          </div>

          <div style={{ marginTop: 8, fontWeight: 600, color: cuadra ? "#237804" : "#cf1322" }}>
            Repartido: {repartido} / Cantidad a entregar: {cantidadEntregar}
            {hayPiezaEnCero && " — hay piezas en 0, ponles cantidad o quítalas"}
          </div>
        </div>

        <div style={{ marginBottom: 6, color: "#cf1322", fontSize: 12 }}>
          Nota: la vista previa (y lo que usan Imprimir/Descargar) no se actualiza hasta que le des clic a <b>"Regenerar Vista Previa"</b>. Tus cambios sí se guardan solos al cerrar el modal, aunque no le hayas dado clic a Regenerar.
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 8,
            marginBottom: 10,
          }}
        >
          <Space wrap>
            <Row align="middle" gutter={4}>
              <Col>
                <label style={{ fontWeight: 600 }}>Ancho (mm)</label>
              </Col>
              <Col>
                <InputNumber min={60} max={200} value={anchoMm} onChange={this.onChangeAnchoMm} style={{ width: 70 }} />
              </Col>
            </Row>
            <Row align="middle" gutter={4}>
              <Col>
                <label style={{ fontWeight: 600 }}>Alto (mm)</label>
              </Col>
              <Col>
                <Tooltip title="Se calcula solo según el ancho y el contenido, para que la etiqueta siempre quede en una sola página. No es editable.">
                  <span style={{ display: "inline-block", minWidth: 70, padding: "4px 8px", background: "#f5f5f5", borderRadius: 4, textAlign: "center" }}>
                    {altoCalculado ?? "—"}
                  </span>
                </Tooltip>
              </Col>
            </Row>
            <Tooltip title={!puedeUsarLogoAlterno ? 'Requiere que el pedido tenga cliente y que "Empresa Alterna en Documentos" esté activo en Complementos, además de que el cliente tenga su empresa alterna activada.' : ""}>
              <Checkbox
                checked={usarLogoAlterno}
                disabled={!puedeUsarLogoAlterno}
                onChange={this.onChangeUsarLogoAlterno}
              >
                Usar logo alterno del cliente
              </Checkbox>
            </Tooltip>
          </Space>
          <Space>
            <ButtonItem
              icon={<ReloadOutlined />}
              type="primary"
              naranja
              onClick={this.regenerar}
            >
              Regenerar Vista Previa
            </ButtonItem>
            <ButtonItem
              icon={<PrinterOutlined />}
              type="primary"
              disabled={!cuadra}
              onClick={this.imprimir}
            >
              Imprimir
            </ButtonItem>
            <ButtonItem
              icon={<DownloadOutlined />}
              type="primary"
              disabled={!cuadra}
              onClick={() => this.descargarPdf()}
            >
              Descargar PDF
            </ButtonItem>
            <ButtonItem danger onClick={this.handleCancel}>
              Cerrar
            </ButtonItem>
          </Space>
        </div>

        {!!this.props.pedidoId && (
          <div style={{ marginBottom: 10 }}>
            <ButtonItem icon={<HistoryOutlined />} morado onClick={this.abrirHistorial}>
              Ver Historial de Entregas
            </ButtonItem>
          </div>
        )}

        <iframe
          title="Etiqueta Entrega Insumo"
          style={{ width: "100%", height: "65vh", border: "1px solid #d9d9d9" }}
          id="EtiquetaEntregaInsumoIframe"
          name="EtiquetaEntregaInsumoIframe"
        />
      </ModalItem>

      <Modal
        title="Historial de Entregas"
        visible={historialVisible}
        onCancel={this.cerrarHistorial}
        footer={<ButtonItem onClick={this.cerrarHistorial}>Cerrar</ButtonItem>}
        width={700}
      >
        {historialLoading ? (
          <div style={{ textAlign: "center", padding: 20 }}>Cargando…</div>
        ) : historial.length === 0 ? (
          <Empty description="Todavía no hay entregas de este insumo para este pedido" />
        ) : (
          historial.map((entry) => {
            const total = (entry.partes || []).reduce((s, p) => s + (Number(p.cantidad) || 0), 0);
            const piezasTexto = (entry.partes || []).map((p) => p.cantidad).join(" / ");
            return (
              <Row key={entry._id} align="middle" gutter={8} style={{ borderBottom: "1px solid #f0f0f0", padding: "8px 0" }}>
                <Col flex="auto">
                  <div style={{ fontWeight: 600 }}>
                    Entrega de {total} — Empacado {entry.fechaEmpaque ? moment(entry.fechaEmpaque).format("DD/MM/YYYY") : "—"}
                  </div>
                  <div style={{ color: "#666", fontSize: 12 }}>
                    Piezas: {piezasTexto || "—"} {entry.leyenda ? `· ${entry.leyenda}` : ""}
                  </div>
                </Col>
                <Col>
                  <Space>
                    <ButtonItem icon={<PrinterOutlined />} onClick={() => this.usarEntradaHistorial(entry, "imprimir")}>
                      Imprimir
                    </ButtonItem>
                    <ButtonItem icon={<DownloadOutlined />} onClick={() => this.usarEntradaHistorial(entry, "descargar")}>
                      Descargar
                    </ButtonItem>
                  </Space>
                </Col>
              </Row>
            );
          })
        )}
      </Modal>
    </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalEtiquetaEntregaInsumo);
